import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
`;

export const FieldContainer = styled.div<{ hasError?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1 1 40%;
  position: relative;
  ${props => props.hasError && `border: 1px solid #D01C2E`}
`;

export const UploadLabel = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 16.41px;
  color: #000;
`;

export const Image = styled.div<{ imageUrl: string; isPlaceholder: boolean; size: 'lg' | 'md'; hasError?: boolean }>`
  background-color: ${props => (props.isPlaceholder ? '#D9D9D9' : 'inherit')};
  background-image: ${({ imageUrl, isPlaceholder }) => (isPlaceholder ? 'none' : `url(${imageUrl})`)};
  background-size: 100% 100%;
  background-repeat: no-repeat;
  min-height: ${props => (props.size === 'lg' ? '244px' : 'auto')};
  max-height: ${props => (props.size === 'lg' ? '244px' : 'auto')};
  aspect-ratio: ${props => (props.size === 'md' ? '1.375 / 1' : 'auto')};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};

  ${props => props.hasError && `background-color: #E933231A`}
`;

export const TopImageRow = styled.div`
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const Label = styled.div<{ displaySize: 'lg' | 'md' }>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);
  text-align: center;
  padding: 1px 4px;
  font-size: 14px;
  font-weight: 600;
  line-height: 16.41px;
  color: #fff;

  & > span {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: ${props => (props.displaySize === 'md' ? '110px' : 'none')};
  }
`;

export const NotesIconWrapper = styled.div`
  display: flex;
  margin-left: auto;
  position: relative;
  width: 24px;
  height: 24px;
  border-radius: 8px;
  align-items: center;
  justify-content: center;

  background: #fff;
`;

export const NotesWrapper = styled.div`
  background: rgba(34, 34, 34, 0.04);
  padding: 8px;
  padding-right: 20px;
  font-family: Roboto;
  font-size: 10px;
  font-weight: 500;
  line-height: 14px;
  color: #000;
  border-radius: 8px;
`;

export const PlaceholderWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: translate(-50%, -50%);
`;

export const PlaceholderLabel = styled.span`
  color: #999999;
  font-size: 10px;
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  z-index: 9999;
  justify-content: center;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none;
  background: rgb(0, 0, 0, 0.2);
`;
